import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { CONFIRM_GUARD_MS } from './CancelTaskConfirm';

/**
 * "Delete this task?" — permanent, so it gets the same double-click guard as
 * CancelTaskConfirm: "No" comes first and takes focus, and "Yes, delete"
 * ignores the second click of a double-click and any click right after the
 * prompt opened. Shared by today's Task Board and the redesigned one.
 */
function DeleteTaskConfirm({ onConfirm, onKeep, classPrefix, buttonClass, dangerClass }) {
    const noRef = useRef(null);
    const openedAt = useRef(Date.now());
    useEffect(() => {
        openedAt.current = Date.now();
        noRef.current?.focus();
    }, []);
    const handleConfirm = (e) => {
        if (e.detail > 1 || Date.now() - openedAt.current < CONFIRM_GUARD_MS) return;
        onConfirm();
    };
    return (
        <div className={`${classPrefix}-cancel-confirm`} role="group" aria-label="Confirm deleting this task">
            <span className={`${classPrefix}-cancel-confirm-text`}>Delete this task?</span>
            <button type="button" ref={noRef} className={buttonClass} onClick={onKeep}>No</button>
            <button type="button" className={`${buttonClass} ${dangerClass}`} onClick={handleConfirm}>Yes, delete</button>
        </div>
    );
}

DeleteTaskConfirm.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onKeep: PropTypes.func.isRequired,
    classPrefix: PropTypes.string.isRequired,
    buttonClass: PropTypes.string.isRequired,
    dangerClass: PropTypes.string.isRequired,
};

export default DeleteTaskConfirm;
